<template>
  <div>
    <el-dialog :visible.sync="open" title="Change Benefit" width="1000px">
      <div class="table_box">
        <el-table :data="tableData">
          <el-table-column label="No." align="center" width="100">
            <template slot-scope="scope">
              <svg-icon icon-class="share_user"
                v-if="scope.row.tnEthAccount === $store.getters.metaMaskObj.account"></svg-icon>
              {{ scope.$index + 1 }}
              <span v-if="scope.row.tnEthAccount === $store.getters.metaMaskObj.account">(YOU)</span>
            </template>
          </el-table-column>
          <el-table-column prop="tnEthAccount" label="Beneficiar">
            <template slot-scope="{ row }">
              <span v-if="row.isOld">{{ row.tnEthAccount }}</span>
              <el-input v-else v-model.trim="row.tnEthAccount" :disabled="!row.isEdit"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="ratio" label="Benefit ratio" width="200">
            <template slot-scope="{ row }">
              <span v-if="row.isOld">{{ row.ratio }} %</span>
              <el-input v-else v-model.number="row.ratio" @change="getOwnRatio(row)">
                <template slot="append">%</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column width="200">
            <template slot-scope="scope">
              <el-button v-if="scope.row.tnEthAccount === $store.getters.metaMaskObj.account && tableData.length < 10"
                type="text" @click="handleAdd(scope.$index)">
                <svg-icon icon-class="share_add"></svg-icon>
                Share
              </el-button>
              <el-button v-if="!scope.row.isOld || (scope.row.ratio == 0 && isOwner)" type="text"
                @click="handleDel(scope.row, scope.$index)" icon="el-icon-delete">
                Delete
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tip">
        <p>Tips:</p>
        <p>
          1. Please ensure that the beneficiary's account is true, accurate, and carefully
          distributed; <br />
          2. After the Rep is minted successfully, it will be automatically sent to the
          beneficiary's account according to the ratio you set.
        </p>
      </div>

      <div class="dialog-footer" slot="footer">
        <el-button @click="handleCancel()">Cancel</el-button>
        <el-button type="primary" @click="handleSubmite()" :loading="btnloading">
          Confirm
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="visible" title="Choose a beneficiary" width="450px">
      <p v-if="stepType === 1">Do you want to divide the benefits to a certain DAPP?</p>
      <div v-if="stepType === 2">
        <p>Divide the beneficiary ratio to DAPP</p>
        <br />
        <el-radio-group v-model="DappRadio">
          <el-radio :label="item.account" v-for="item in dappList" :key="item.name">
            <!-- {{ item.name }} -->
            Defi
          </el-radio>
        </el-radio-group>
      </div>
      <div class="dialog-footer" slot="footer">
        <template v-if="stepType === 1">
          <el-button @click="selectedDapp('no')">No</el-button>
          <el-button type="primary" @click="selectedDapp('yes')">Yes</el-button>
        </template>
        <template v-if="stepType === 2">
          <el-button @click="selectedDapp('back')">Back</el-button>
          <el-button type="primary" :disabled="!DappRadio" @click="selectedDapp('submit')">Submit</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { availableList } from "@/api/file.js";
export default {
  data() {
    return {
      open: false,
      form: {
        code: undefined,
      },
      oldList: [],
      newList: [],
      ownerindex: 0,
      ownerRatio: undefined,
      producerContract: undefined,
      producerAddress: undefined,
      uniqueId: undefined,
      isOwner: false,
      btnloading: false,
      // --------------
      visible: false,
      stepType: 1,
      DappRadio: undefined,
      dappList: [],
    };
  },
  computed: {
    tableData() {
      return [...this.oldList, ...this.newList];
    },
  },
  methods: {
    getabi(name) {
      this.getAbi(name).then((res) => {
        this.producerContract = new web3.eth.Contract(res.data.abi, res.data.address);
        this.producerAddress = res.data.address;
      });
    },
    show(row) {
      this.uniqueId = web3.utils.padRight(web3.utils.toHex(row.wellID), 64);
      this.isOwner =
        row.beneficiaries[0].tnEthAccount === this.$store.getters.metaMaskObj.account;
      this.getabi(row.type === 'OIL' ? "OilProducer" : "GasProducer");
      this.oldList = row.beneficiaries.map((item, index) => {
        if (item.tnEthAccount === this.$store.getters.metaMaskObj.account) {
          this.ownerindex = index;
          this.ownerRatio = item.ratio;
        }
        return {
          ...item,
          isOld: true,
        };
      });
      this.open = true;
    },
    handleAdd() {
      let len = this.tableData.length;
      if (this.tableData[len - 1].tnEthAccount == "") {
        this.$message.warning(`Please fill in item ${len} of the data first`);
        return false;
      }
      this.visible = true;
      this.stepType = 1
      this.DappRadio = undefined
    },
    selectedDapp(val) {
      console.log('val',val)
      if (val === "no") {
        this.visible = false;
        this.newList.push({
          tnEthAccount: "",
          ratio: 0,
          isEdit: true,
        });
      } else if (val === "yes") {
        this.DappRadio = undefined;
        if (this.dappList.length > 0) {
          this.stepType = 2;
        } else {
          availableList().then((res) => {
            this.dappList = res.data;
            this.stepType = 2;
          });
        }
      } else if (val === "back") {
        this.stepType = 1;
      } else {
        this.visible = false;
        this.newList.push({
          tnEthAccount: this.DappRadio,
          ratio: 0,
          isEdit: false,
        });
      }
    },
    handleDel(row, index) {
      if (row.isOld) {
        const tx_builder = this.producerContract.methods["deleteHolder"](
          this.uniqueId,
          row.tnEthAccount
        );
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.producerAddress,
          value: 0,
          data: encoded_tx,
        };
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            this.$message.success("delete success!");
            this.oldList.splice(index, 1);
          })
          .catch((error) => {
            this.$message.error("operation failed");
            console.error(error);
          });
      } else {
        this.newList.splice(index - this.oldList.length, 1);
        this.getOwnRatio();
      }
    },
    getOwnRatio(row) {
      let total = this.newList.reduce((pre, cur) => pre + Number(cur.ratio), 0);
      if (row) {
        if (!isNaN(row.ratio) && row.ratio >= 0 && row.ratio <= (this.ownerRatio - total + row.ratio)) {
          if (this.ownerindex === 0 && total >= this.ownerRatio) {
            row.ratio = 0;
          } else if (this.ownerindex > 0 && total > this.ownerRatio) {
            row.ratio = 0;
          }
          this.oldList[this.ownerindex].ratio = this.ownerRatio - total;
        } else {
          this.oldList[this.ownerindex].ratio = this.ownerRatio - total + row.ratio;
          row.ratio = 0;
        }
      } else {
        this.oldList[this.ownerindex].ratio = this.ownerRatio - total;
      }
    },
    handleCancel() {
      this.open = false;
      this.newList = [];
    },
    checkData() {
      let len = this.tableData.length;
      if (this.tableData[len - 1].tnEthAccount == "") {
        this.$message.warning(`Please fill in item ${len} of the data`);
        return false;
      }
      let addressArr = [],
        ratioArr = [];
      this.newList.forEach((item) => {
        let newRatio = undefined
        let newRatioArr = []
        this.oldList.forEach((oldItem) => {
          if(item.tnEthAccount.toLowerCase() === oldItem.tnEthAccount.toLowerCase()){
            newRatioArr.push(item.ratio + oldItem.ratio)
          }else{
            newRatioArr.push(item.ratio)
          }
        })
        newRatio = Math.max.apply(null,newRatioArr);
        addressArr.push(item.tnEthAccount);
        ratioArr.push(newRatio);
      });

      let newAddressArr = [...new Set(addressArr)];
      if (newAddressArr.length < ratioArr.length) {
        this.$message.warning(
          "This beneficiary already exists in this well, please do not repeat!"
        );
        return false;
      }
      return {
        addressArr: addressArr,
        ratioArr: ratioArr,
      };
    },
    handleSubmite() {
      this.btnloading = true;
      let data = this.checkData();
      console.log(this.isOwner)
      console.log(data)
      if (data) {
        if (this.isOwner) {
          this.ownerSubmite(this.uniqueId, data)
            .then((res) => {
              this.$message.success("Submitted successfully！");
              this.btnloading = false;
              this.handleCancel();
            })
            .catch((err) => {
              this.btnloading = false;
              console.log(err);
            });
        } else {
          let reqList = [];
          this.newList.forEach((item) => {
            reqList.push(this.otherSubmite(this.uniqueId, item));
          });
          Promise.all(reqList)
            .then((res) => {
              this.$message.success("Submitted successfully！");
              this.handleCancel();
              this.btnloading = false;
            })
            .catch((err) => {
              console.log(err);
              this.btnloading = false;
            });
        }
      }
    },
    ownerSubmite(uniqueId, data) {
      return new Promise((resolve, reject) => {
        const tx_builder = this.producerContract.methods["setHolders"](
          uniqueId,
          data.addressArr,
          data.ratioArr
        );
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.producerAddress,
          value: 0,
          data: encoded_tx,
        };
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve();
          })
          .catch((error) => {
            reject();
            this.$message.error("operation failed");
            console.error(error);
          });
      });
    },
    otherSubmite(uniqueId, data) {
      return new Promise((resolve, reject) => {
        const tx_builder = this.producerContract.methods["splitHolder"](
          uniqueId,
          data.tnEthAccount,
          data.ratio
        );
        const encoded_tx = tx_builder.encodeABI();

        let json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.producerAddress,
          value: 0,
          data: encoded_tx,
        };
        web3.eth
          .sendTransaction(json)
          .then((res) => {
            resolve();
          })
          .catch((error) => {
            reject();
            this.$message.error("operation failed");
            console.error(error);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table_box {
  overflow: hidden;
}

.tip {
  background: #fafafa;
  padding: 0.12rem 0.5rem;
  display: flex;
  font-size: 0.16rem;
  font-family: Roboto-Regular, Roboto;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.28rem;

  p:first-child {
    width: 0.6rem;
  }
}
</style>
